import React from 'react'

const Map = () => {
  return (
    <div>
      <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d26517.772074368182!2d-84.24574196523442!3d33.81949920000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1701576436217!5m2!1sen!2sus" className=' w-full h-96' allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
  )
}

export default Map
